import { Injectable } from '@angular/core';
import { Color } from '@lsq-frontend/common-ui';
import { InvoiceSummary } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { I18n } from '@ngx-translate/i18n-polyfill';

export class UiInvoiceSummary extends InvoiceSummary {
    public isSelected = false;
}

export interface IInvoiceState {
    statusText: string;
    color?: Color;
}
@Injectable({ providedIn: 'root' })
export class InvoiceFundingStatusDisplay {
    public UNFUNDED = this._i18n('Eligible');
    public ELIGIBLE = this._i18n('Eligible');
    public PENDING = this._i18n('Pending');
    public FUNDED = this._i18n('Early Paid');
    public EARLY_PAID = this._i18n('Early Paid');
    public SENT = this._i18n('Early Paid');
    public WILL_NOT_FUND = this._i18n('Ineligible');
    public INELIGIBLE = this._i18n('Ineligible');
    public SCHEDULED = this._i18n('Scheduled');
    public ADJUSTMENT = this._i18n('Adjustment');
    public CLOSED = this._i18n('Closed');
    public EARLY_PAID_CLOSED = this._i18n('Early Paid');
    public PAID = this._i18n('Paid');
    public UNKNOWN_STATUS = this._i18n('Processing');
    public CREDIT_MEMO = this._i18n('Credit Memo');
    public REVOKED = this._i18n('Revoked');
    public PAY_LATER = this._i18n('FlexTerm');
    public PAY_LATER_CLOSED = this._i18n('FlexTerm');

    constructor(private _i18n: I18n) {}
}

export enum InvoiceFundingStatusDotEnum {
    UNFUNDED = 'Approved',
    ELIGIBLE = 'Approved',
    PENDING = 'UnderReview',
    FUNDED = 'EarlyPaid',
    EARLY_PAID = 'EarlyPaid',
    EARLY_PAID_CLOSED = 'EarlyPaid',
    SENT = 'EarlyPaid',
    INELIGIBLE = 'Rejected',
    WILL_NOT_FUND = 'Rejected',
    UNKNOWN_STATUS = 'UnderReview',
    SCHEDULED = 'Scheduled',
    PAID = 'Paid'
}

@Injectable({ providedIn: 'root' })
export class InvoiceBuyerApprovalStatusDisplay {
    public IN_REVIEW = this._i18n('In Review');
    public APPROVED = this._i18n('Approved');
    public REJECTED = this._i18n('Rejected');

    constructor(private _i18n: I18n) {}
}

export enum InvoiceBuyerApprovalStatusDotEnum {
    IN_REVIEW = 'UnderReview',
    APPROVED = 'Approved',
    REJECTED = 'Rejected'
}

@Injectable({ providedIn: 'root' })
export class FundingBatchStatusDisplay {
    public UNKNOWN_FUNDING_STATUS = this._i18n('Pending');
    public STAGED = this._i18n('Pending');
    public REJECTED = this._i18n('Ineligible');
    public SENT = this._i18n('Processed');
    public IN_TRANSFER = this._i18n('Pending');
    public CANCELLED = this._i18n('Ineligible');

    constructor(private _i18n: I18n) {}
}

export enum FundingBatchStatusDotEnum {
    UNKNOWN_FUNDING_STATUS = 'Disabled',
    STAGED = 'Pending',
    REJECTED = 'Rejected',
    SENT = 'Approved',
    IN_TRANSFER = 'Pending',
    CANCELLED = 'Rejected'
}
@Injectable({ providedIn: 'root' })
export class SellerEarlyPaymentStatusDisplay {
    public EP_SCHEDULED = this._i18n('Scheduled');
    public EP_PENDING = this._i18n('Pending');
    public EP_REJECTED = this._i18n('Rejected');
    public EP_FUNDED = this._i18n('Early Paid');
    public EP_FUNDED_TERMS = this._i18n('Paid');
    public EP_FUNDED_TERMS_PAY_LATER = this._i18n('Paid');

    constructor(private _i18n: I18n) {}
}

@Injectable({ providedIn: 'root' })
export class SupplierStatusDisplay {
    public ENROLLED = this._i18n('Enrolled');
    public NOT_ENROLLED = this._i18n('Not Enrolled');
    public INELIGIBLE = this._i18n('Ineligible');

    constructor(private _i18n: I18n) {}
}

export enum EarlyPaymentStatusDotEnum {
    EP_SCHEDULED = 'SCHEDULED',
    EP_PENDING = 'PENDING',
    EP_REJECTED = 'REJECTED',
    EP_FUNDED = 'EARLYPAID',
    EP_FUNDED_TERMS = 'PAID'
}
